import { api } from '@/api'
import MediaPhotosCard from '@/components/Cards/MediaPhotosCard'
import MediaVideoCard from '@/components/Cards/MediaVideoCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { Media } from '@/interfaces/Media'
import React, { useEffect, useState } from 'react'
import style from '../styles/media_detail.module.scss'

const MoreMedia = (): React.ReactElement => {
  const [media, setMedia] = useState<Media[]>()

  const page = usePage()
  const { config } = page.init_state.global

  useEffect(() => {
    api
      .getMediaList({ page_size: 2 })
      .then((data) => {
        setMedia(data.results)
      })
      .catch((error) => {
        console.log(error, 'error')
      })
  }, [])

  if (media != null && media.length > 0) {
    return (
      <Section>
        <Title type='h2' theme='h1' className={style.detail__title}>
          Еще медиа
        </Title>
        <div className={style.more}>
          {media.map((el) => {
            if (el.video === null) {
              return (
                <MediaPhotosCard
                  key={el.id}
                  title={el.name}
                  image={el.picture}
                  count={el.count}
                  date={el.date_create}
                  id={el.id}
                  baseUrl={config.media_detail}
                  className={style.media__item}
                />
              )
            } else {
              return (
                <MediaVideoCard
                  key={el.id}
                  title={el.name}
                  image={el.picture}
                  id={el.id}
                  baseUrl={config.media_detail}
                  className={style.media__item}
                />
              )
            }
          })}
        </div>
      </Section>
    )
  } else {
    return <></>
  }
}

export default MoreMedia
